/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { DayOfWeek } from 'app/shared/model/enumerations/day-of-week.model';
import { RecurrenceType } from 'app/shared/model/enumerations/recurrence-type.model';
import { ConsultType } from 'app/shared/model/enumerations/consult-type.model';
import { createEntity, getEntity, reset, updateEntity } from './doctor-availability.reducer';

export const DoctorAvailabilityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const doctors = useAppSelector(state => state.doctor.entities);
  const hospitals = useAppSelector(state => state.hospital.entities);
  const doctorAvailabilityEntity = useAppSelector(state => state.doctorAvailability.entity);
  const loading = useAppSelector(state => state.doctorAvailability.loading);
  const updating = useAppSelector(state => state.doctorAvailability.updating);
  const updateSuccess = useAppSelector(state => state.doctorAvailability.updateSuccess);
  const dayOfWeekValues = Object.keys(DayOfWeek);
  const recurrenceTypeValues = Object.keys(RecurrenceType);
  const consultTypeValues = Object.keys(ConsultType);

  const handleClose = () => {
    navigate(`/doctor-availability${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDoctors({}));
    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.startTime !== undefined && typeof values.startTime !== 'number') {
      values.startTime = Number(values.startTime);
    }
    if (values.endTime !== undefined && typeof values.endTime !== 'number') {
      values.endTime = Number(values.endTime);
    }
    if (values.startDate !== undefined && typeof values.startDate !== 'number') {
      values.startDate = Number(values.startDate);
    }
    if (values.endDate !== undefined && typeof values.endDate !== 'number') {
      values.endDate = Number(values.endDate);
    }
    if (values.NoOfAppts !== undefined && typeof values.NoOfAppts !== 'number') {
      values.NoOfAppts = Number(values.NoOfAppts);
    }
    if (values.NoOfSlotsForSchedule !== undefined && typeof values.NoOfSlotsForSchedule !== 'number') {
      values.NoOfSlotsForSchedule = Number(values.NoOfSlotsForSchedule);
    }

    const entity = {
      ...doctorAvailabilityEntity,
      ...values,
      doctorId: doctors.find(it => it.id.toString() === values.doctorId?.toString()),
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          dayOfWeek: 'SUNDAY',
          recurrenceType: 'DAILY',
          consultType: 'VIRTUAL',
          ...doctorAvailabilityEntity,
          doctorId: doctorAvailabilityEntity?.doctorId?.id,
          hospital: doctorAvailabilityEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.doctorAvailability.home.createOrEditLabel" data-cy="DoctorAvailabilityCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.doctorAvailability.home.createOrEditLabel">
              Create or edit a DoctorAvailability
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="doctor-availability-id"
                  label={translate('tinyMedicRestApp.doctorAvailability.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.dayOfWeek')}
                id="doctor-availability-dayOfWeek"
                name="dayOfWeek"
                data-cy="dayOfWeek"
                type="select"
              >
                {dayOfWeekValues.map(dayOfWeek => (
                  <option value={dayOfWeek} key={dayOfWeek}>
                    {translate(`tinyMedicRestApp.DayOfWeek.${dayOfWeek}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.recurrenceType')}
                id="doctor-availability-recurrenceType"
                name="recurrenceType"
                data-cy="recurrenceType"
                type="select"
              >
                {recurrenceTypeValues.map(recurrenceType => (
                  <option value={recurrenceType} key={recurrenceType}>
                    {translate(`tinyMedicRestApp.RecurrenceType.${recurrenceType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.timestampentry')}
                id="doctor-availability-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.microSec')}
                id="doctor-availability-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.lastupdated')}
                id="doctor-availability-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.active')}
                id="doctor-availability-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.cursor')}
                id="doctor-availability-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.startTime')}
                id="doctor-availability-startTime"
                name="startTime"
                data-cy="startTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.endTime')}
                id="doctor-availability-endTime"
                name="endTime"
                data-cy="endTime"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.startDate')}
                id="doctor-availability-startDate"
                name="startDate"
                data-cy="startDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.endDate')}
                id="doctor-availability-endDate"
                name="endDate"
                data-cy="endDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.draft')}
                id="doctor-availability-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.suspended')}
                id="doctor-availability-suspended"
                name="suspended"
                data-cy="suspended"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.enforceSchedule')}
                id="doctor-availability-enforceSchedule"
                name="enforceSchedule"
                data-cy="enforceSchedule"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.consultType')}
                id="doctor-availability-consultType"
                name="consultType"
                data-cy="consultType"
                type="select"
              >
                {consultTypeValues.map(consultType => (
                  <option value={consultType} key={consultType}>
                    {translate(`tinyMedicRestApp.ConsultType.${consultType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.NoOfAppts')}
                id="doctor-availability-NoOfAppts"
                name="NoOfAppts"
                data-cy="NoOfAppts"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.doctorAvailability.NoOfSlotsForSchedule')}
                id="doctor-availability-NoOfSlotsForSchedule"
                name="NoOfSlotsForSchedule"
                data-cy="NoOfSlotsForSchedule"
                type="text"
              />
              <ValidatedField
                id="doctor-availability-doctorId"
                name="doctorId"
                data-cy="doctorId"
                label={translate('tinyMedicRestApp.doctorAvailability.doctorId')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="doctor-availability-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.doctorAvailability.hospital')}
                type="select"
                required
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/doctor-availability" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DoctorAvailabilityUpdate;
